// extracted by mini-css-extract-plugin
export default {"root":"Text_root__Y5mmK","onDark":"Text_onDark__EdASB"};